import { PageEnum } from "src/helpers/Enums";

export default function MenuIcon(props) {
  switch (props.menu) {
    case PageEnum.DASHBOARD:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.size}
          height={props.size}
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M6 12.75H12M8.26327 2.07301L3.17654 6.02936C2.83652 6.29382 2.6665 6.42606 2.54402 6.59166C2.43552 6.73835 2.3547 6.9036 2.30552 7.0793C2.25 7.27765 2.25 7.49304 2.25 7.9238V13.35C2.25 14.1901 2.25 14.6101 2.41349 14.931C2.5573 15.2132 2.78677 15.4427 3.06901 15.5865C3.38988 15.75 3.80992 15.75 4.65 15.75H13.35C14.1901 15.75 14.6101 15.75 14.931 15.5865C15.2132 15.4427 15.4427 15.2132 15.5865 14.931C15.75 14.6101 15.75 14.1901 15.75 13.35V7.9238C15.75 7.49304 15.75 7.27765 15.6945 7.0793C15.6453 6.9036 15.5645 6.73835 15.456 6.59166C15.3335 6.42606 15.1635 6.29382 14.8235 6.02936L9.73673 2.07301C9.47324 1.86807 9.34149 1.7656 9.19601 1.72622C9.06765 1.69146 8.93235 1.69146 8.80399 1.72622C8.65851 1.7656 8.52677 1.86807 8.26327 2.07301Z"
            stroke={props.color}
            stroke-width="1.66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case PageEnum.ALLCALENDAR:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.size}
          height={props.size}
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z"
            stroke={props.color}
            stroke-width="1.66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case PageEnum.LISTS:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.size}
          height={props.size}
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M2.25 6.75H15.75M2.25 11.25H15.75M5.85 2.25H12.15C13.4101 2.25 14.0402 2.25 14.5215 2.49524C14.9448 2.71095 15.289 3.05516 15.5048 3.47852C15.75 3.95982 15.75 4.58988 15.75 5.85V12.15C15.75 13.4101 15.75 14.0402 15.5048 14.5215C15.289 14.9448 14.9448 15.289 14.5215 15.5048C14.0402 15.75 13.4101 15.75 12.15 15.75H5.85C4.58988 15.75 3.95982 15.75 3.47852 15.5048C3.05516 15.289 2.71095 14.9448 2.49524 14.5215C2.25 14.0402 2.25 13.4101 2.25 12.15V5.85C2.25 4.58988 2.25 3.95982 2.49524 3.47852C2.71095 3.05516 3.05516 2.71095 3.47852 2.49524C3.95982 2.25 4.58988 2.25 5.85 2.25Z"
            stroke={props.color}
            stroke-width="1.66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case PageEnum.CREATIVES:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.size}
          height={props.size}
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clip-path="url(#clip0_3886_19299)">
            <path
              d="M4.875 9.75L5.46334 10.9267C5.66246 11.3249 5.76202 11.524 5.89502 11.6966C6.01304 11.8497 6.15031 11.987 6.30341 12.105C6.47596 12.238 6.67508 12.3375 7.07331 12.5367L8.25 13.125L7.07331 13.7133C6.67508 13.9125 6.47596 14.012 6.30342 14.145C6.15031 14.263 6.01304 14.4003 5.89502 14.5534C5.76202 14.726 5.66246 14.9251 5.46334 15.3233L4.875 16.5L4.28666 15.3233C4.08754 14.9251 3.98798 14.726 3.85498 14.5534C3.73696 14.4003 3.59969 14.263 3.44659 14.145C3.27404 14.012 3.07492 13.9125 2.67669 13.7133L1.5 13.125L2.67669 12.5367C3.07492 12.3375 3.27404 12.238 3.44658 12.105C3.59969 11.987 3.73696 11.8497 3.85498 11.6966C3.98798 11.524 4.08754 11.3249 4.28666 10.9267L4.875 9.75Z"
              stroke="#8185A8"
              stroke-width="1.66"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.25 1.5L12.134 3.79831C12.3455 4.34824 12.4512 4.6232 12.6157 4.85448C12.7614 5.05947 12.9405 5.23856 13.1455 5.38431C13.3768 5.54877 13.6518 5.65452 14.2017 5.86603L16.5 6.75L14.2017 7.63397C13.6518 7.84548 13.3768 7.95123 13.1455 8.11569C12.9405 8.26144 12.7614 8.44054 12.6157 8.64552C12.4512 8.8768 12.3455 9.15176 12.134 9.70169L11.25 12L10.366 9.70169C10.1545 9.15176 10.0488 8.8768 9.88431 8.64552C9.73856 8.44054 9.55947 8.26144 9.35448 8.11569C9.1232 7.95123 8.84824 7.84548 8.29831 7.63397L6 6.75L8.29831 5.86603C8.84824 5.65452 9.1232 5.54877 9.35448 5.38431C9.55946 5.23856 9.73856 5.05947 9.88431 4.85448C10.0488 4.6232 10.1545 4.34824 10.366 3.79831L11.25 1.5Z"
              stroke={props.color}
              stroke-width="1.66"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3886_19299">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case PageEnum.OFFERS:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.size}
          height={props.size}
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M13.125 12.75H4.875M13.125 9.75H4.875M2.25 6.75H15.75M5.85 2.25H12.15C13.4101 2.25 14.0402 2.25 14.5215 2.49524C14.9448 2.71095 15.289 3.05516 15.5048 3.47852C15.75 3.95982 15.75 4.58988 15.75 5.85V12.15C15.75 13.4101 15.75 14.0402 15.5048 14.5215C15.289 14.9448 14.9448 15.289 14.5215 15.5048C14.0402 15.75 13.4101 15.75 12.15 15.75H5.85C4.58988 15.75 3.95982 15.75 3.47852 15.5048C3.05516 15.289 2.71095 14.9448 2.49524 14.5215C2.25 14.0402 2.25 13.4101 2.25 12.15V5.85C2.25 4.58988 2.25 3.95982 2.49524 3.47852C2.71095 3.05516 3.05516 2.71095 3.47852 2.49524C3.95982 2.25 4.58988 2.25 5.85 2.25Z"
            stroke={props.color}
            stroke-width="1.66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case PageEnum.STRATEGIES:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.size}
          height={props.size}
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clip-path="url(#clip0_44_719)">
            <path
              d="M8.25 3.375H13.725C14.5651 3.375 14.9851 3.375 15.306 3.53849C15.5882 3.6823 15.8177 3.91177 15.9615 4.19401C16.125 4.51488 16.125 4.93492 16.125 5.775V6.75C16.125 7.44891 16.125 7.79837 16.0108 8.07403C15.8586 8.44157 15.5666 8.73358 15.199 8.88582C14.9234 9 14.5739 9 13.875 9M9.75 14.625H4.275C3.43492 14.625 3.01488 14.625 2.69401 14.4615C2.41177 14.3177 2.1823 14.0882 2.03849 13.806C1.875 13.4851 1.875 13.0651 1.875 12.225V11.25C1.875 10.5511 1.875 10.2016 1.98918 9.92598C2.14142 9.55843 2.43343 9.26642 2.80097 9.11418C3.07663 9 3.42609 9 4.125 9M7.725 10.875H10.275C10.485 10.875 10.59 10.875 10.6702 10.8341C10.7408 10.7982 10.7982 10.7408 10.8341 10.6702C10.875 10.59 10.875 10.485 10.875 10.275V7.725C10.875 7.51498 10.875 7.40997 10.8341 7.32975C10.7982 7.25919 10.7408 7.20183 10.6702 7.16587C10.59 7.125 10.485 7.125 10.275 7.125H7.725C7.51498 7.125 7.40997 7.125 7.32975 7.16587C7.25919 7.20183 7.20183 7.25919 7.16587 7.32975C7.125 7.40997 7.125 7.51498 7.125 7.725V10.275C7.125 10.485 7.125 10.59 7.16587 10.6702C7.20183 10.7408 7.25919 10.7982 7.32975 10.8341C7.40997 10.875 7.51498 10.875 7.725 10.875ZM13.35 16.5H15.9C16.11 16.5 16.215 16.5 16.2952 16.4591C16.3658 16.4232 16.4232 16.3658 16.4591 16.2952C16.5 16.215 16.5 16.11 16.5 15.9V13.35C16.5 13.14 16.5 13.035 16.4591 12.9548C16.4232 12.8842 16.3658 12.8268 16.2952 12.7909C16.215 12.75 16.11 12.75 15.9 12.75H13.35C13.14 12.75 13.035 12.75 12.9548 12.7909C12.8842 12.8268 12.8268 12.8842 12.7909 12.9548C12.75 13.035 12.75 13.14 12.75 13.35V15.9C12.75 16.11 12.75 16.215 12.7909 16.2952C12.8268 16.3658 12.8842 16.4232 12.9548 16.4591C13.035 16.5 13.14 16.5 13.35 16.5ZM2.1 5.25H4.65C4.86002 5.25 4.96503 5.25 5.04525 5.20913C5.11581 5.17317 5.17317 5.11581 5.20913 5.04525C5.25 4.96503 5.25 4.86002 5.25 4.65V2.1C5.25 1.88998 5.25 1.78497 5.20913 1.70475C5.17317 1.63419 5.11581 1.57683 5.04525 1.54087C4.96503 1.5 4.86002 1.5 4.65 1.5H2.1C1.88998 1.5 1.78497 1.5 1.70475 1.54087C1.63419 1.57683 1.57683 1.63419 1.54087 1.70475C1.5 1.78497 1.5 1.88998 1.5 2.1V4.65C1.5 4.86002 1.5 4.96503 1.54087 5.04525C1.57683 5.11581 1.63419 5.17317 1.70475 5.20913C1.78497 5.25 1.88998 5.25 2.1 5.25Z"
              stroke={props.color}
              stroke-width="1.66"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_44_719">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case PageEnum.SEARCH:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
        >
          <path
            d="M56 56L46.6669 46.6667M53.3333 30.6667C53.3333 43.1851 43.1851 53.3333 30.6667 53.3333C18.1482 53.3333 8 43.1851 8 30.6667C8 18.1482 18.1482 8 30.6667 8C43.1851 8 53.3333 18.1482 53.3333 30.6667Z"
            stroke="#7E50EA"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case PageEnum.SETTINGS:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.size}
          height={props.size}
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clip-path="url(#clip0_4048_35157)">
            <path
              d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
              stroke={props.color}
              stroke-width="1.66"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.0455 11.0455C13.9547 11.2511 13.9276 11.4792 13.9677 11.7004C14.0078 11.9216 14.1133 12.1257 14.2705 12.2864L14.3114 12.3273C14.4382 12.4539 14.5387 12.6043 14.6074 12.7699C14.676 12.9354 14.7113 13.1128 14.7113 13.292C14.7113 13.4712 14.676 13.6487 14.6074 13.8142C14.5387 13.9798 14.4382 14.1302 14.3114 14.2568C14.1847 14.3836 14.0343 14.4842 13.8688 14.5528C13.7032 14.6214 13.5258 14.6568 13.3466 14.6568C13.1674 14.6568 12.9899 14.6214 12.8244 14.5528C12.6589 14.4842 12.5085 14.3836 12.3818 14.2568L12.3409 14.2159C12.1802 14.0587 11.9761 13.9533 11.7549 13.9132C11.5338 13.8731 11.3056 13.9001 11.1 13.9909C10.8983 14.0773 10.7264 14.2208 10.6052 14.4038C10.4841 14.5867 10.4191 14.8011 10.4182 15.0205V15.1364C10.4182 15.498 10.2745 15.8449 10.0188 16.1006C9.76305 16.3563 9.4162 16.5 9.05455 16.5C8.69289 16.5 8.34604 16.3563 8.09031 16.1006C7.83458 15.8449 7.69091 15.498 7.69091 15.1364V15.075C7.68563 14.8493 7.61258 14.6305 7.48126 14.4468C7.34993 14.2632 7.16641 14.1234 6.95455 14.0455C6.7489 13.9547 6.52078 13.9276 6.2996 13.9677C6.07842 14.0078 5.87433 14.1133 5.71364 14.2705L5.67273 14.3114C5.54608 14.4382 5.39569 14.5387 5.23015 14.6074C5.0646 14.676 4.88716 14.7113 4.70795 14.7113C4.52875 14.7113 4.35131 14.676 4.18576 14.6074C4.02022 14.5387 3.86983 14.4382 3.74318 14.3114C3.6164 14.1847 3.51582 14.0343 3.44719 13.8688C3.37857 13.7032 3.34325 13.5258 3.34325 13.3466C3.34325 13.1674 3.37857 12.9899 3.44719 12.8244C3.51582 12.6589 3.6164 12.5085 3.74318 12.3818L3.78409 12.3409C3.94128 12.1802 4.04672 11.9761 4.08682 11.7549C4.12693 11.5338 4.09985 11.3056 4.00909 11.1C3.92266 10.8983 3.77915 10.7264 3.59623 10.6052C3.4133 10.4841 3.19895 10.4191 2.97955 10.4182H2.86364C2.50198 10.4182 2.15513 10.2745 1.8994 10.0188C1.64367 9.76305 1.5 9.4162 1.5 9.05455C1.5 8.69289 1.64367 8.34604 1.8994 8.09031C2.15513 7.83458 2.50198 7.69091 2.86364 7.69091H2.925C3.15068 7.68563 3.36955 7.61258 3.55316 7.48126C3.73677 7.34993 3.87662 7.16641 3.95455 6.95455C4.04531 6.7489 4.07238 6.52078 4.03228 6.2996C3.99217 6.07842 3.88673 5.87433 3.72955 5.71364L3.68864 5.67273C3.56185 5.54608 3.46127 5.39569 3.39265 5.23015C3.32402 5.0646 3.2887 4.88716 3.2887 4.70795C3.2887 4.52875 3.32402 4.35131 3.39265 4.18576C3.46127 4.02022 3.56185 3.86983 3.68864 3.74318C3.81528 3.6164 3.96568 3.51582 4.13122 3.44719C4.29676 3.37857 4.47421 3.34325 4.65341 3.34325C4.83261 3.34325 5.01006 3.37857 5.1756 3.44719C5.34114 3.51582 5.49154 3.6164 5.61818 3.74318L5.65909 3.78409C5.81978 3.94128 6.02387 4.04672 6.24505 4.08682C6.46623 4.12693 6.69435 4.09985 6.9 4.00909H6.95455C7.15621 3.92266 7.32819 3.77915 7.44934 3.59623C7.57048 3.4133 7.63549 3.19895 7.63636 2.97955V2.86364C7.63636 2.50198 7.78003 2.15513 8.03576 1.8994C8.2915 1.64367 8.63834 1.5 9 1.5C9.36166 1.5 9.7085 1.64367 9.96424 1.8994C10.22 2.15513 10.3636 2.50198 10.3636 2.86364V2.925C10.3645 3.1444 10.4295 3.35876 10.5507 3.54168C10.6718 3.72461 10.8438 3.86812 11.0455 3.95455C11.2511 4.04531 11.4792 4.07238 11.7004 4.03228C11.9216 3.99217 12.1257 3.88673 12.2864 3.72955L12.3273 3.68864C12.4539 3.56185 12.6043 3.46127 12.7699 3.39265C12.9354 3.32402 13.1128 3.2887 13.292 3.2887C13.4712 3.2887 13.6487 3.32402 13.8142 3.39265C13.9798 3.46127 14.1302 3.56185 14.2568 3.68864C14.3836 3.81528 14.4842 3.96568 14.5528 4.13122C14.6214 4.29676 14.6568 4.47421 14.6568 4.65341C14.6568 4.83261 14.6214 5.01006 14.5528 5.1756C14.4842 5.34114 14.3836 5.49154 14.2568 5.61818L14.2159 5.65909C14.0587 5.81978 13.9533 6.02387 13.9132 6.24505C13.8731 6.46623 13.9001 6.69435 13.9909 6.9V6.95455C14.0773 7.15621 14.2208 7.32819 14.4038 7.44934C14.5867 7.57048 14.8011 7.63549 15.0205 7.63636H15.1364C15.498 7.63636 15.8449 7.78003 16.1006 8.03576C16.3563 8.2915 16.5 8.63834 16.5 9C16.5 9.36166 16.3563 9.7085 16.1006 9.96424C15.8449 10.22 15.498 10.3636 15.1364 10.3636H15.075C14.8556 10.3645 14.6412 10.4295 14.4583 10.5507C14.2754 10.6718 14.1319 10.8438 14.0455 11.0455Z"
              stroke={props.color}
              stroke-width="1.66"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4048_35157">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case PageEnum.SMS_ANALYTICS:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="ml-7"
          width={props.size}
          height={props.size}
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M11.3281 5.33008L7.25239 9.40581C7.10388 9.55432 7.02963 9.62857 6.94401 9.65639C6.86869 9.68087 6.78756 9.68087 6.71224 9.65639C6.62662 9.62857 6.55237 9.55432 6.40386 9.40581L5.00239 8.00434C4.85388 7.85584 4.77963 7.78158 4.69401 7.75376C4.61869 7.72929 4.53756 7.72929 4.46224 7.75376C4.37662 7.78158 4.30237 7.85584 4.15386 8.00434L0.828125 11.3301M11.3281 8.33008V5.33008H8.32812M4.42812 14.3301H10.7281C11.9882 14.3301 12.6183 14.3301 13.0996 14.0848C13.523 13.8691 13.8672 13.5249 14.0829 13.1016C14.3281 12.6203 14.3281 11.9902 14.3281 10.7301V4.43008C14.3281 3.16996 14.3281 2.5399 14.0829 2.0586C13.8672 1.63523 13.523 1.29103 13.0996 1.07531C12.6183 0.830078 11.9882 0.830078 10.7281 0.830078H4.42813C3.16801 0.830078 2.53795 0.830078 2.05665 1.07531C1.63328 1.29103 1.28908 1.63523 1.07336 2.0586C0.828125 2.5399 0.828125 3.16996 0.828125 4.43008V10.7301C0.828125 11.9902 0.828125 12.6203 1.07336 13.1016C1.28908 13.5249 1.63328 13.8691 2.05665 14.0848C2.53795 14.3301 3.16801 14.3301 4.42812 14.3301Z"
            stroke={props.color}
            stroke-width="1.66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={"ml-7"}
          width={props.size}
          height={props.size}
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3.75 9H14.25M14.25 9L9 3.75M14.25 9L9 14.25"
            stroke={props.color}
            stroke-width="1.66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
  }
}
